import STORE from '../../store';
import invalidateMetricCache from './invalidateMetricCache';

const updateMetric = async (
  id: string,
  newMetric: Metrics.NormalMetric,
  selectedAccountId: string,
) => {
  await STORE.metricDefinitions
    .getNormalMetricsRef({ accountId: selectedAccountId })
    .doc(id)
    .set(newMetric);

  await invalidateMetricCache({
    accountId: selectedAccountId,
    normalMetricIds: [id],
  });
};

export default updateMetric;
